import React from 'react';
import Grid from '@mui/material/Unstable_Grid2';

import './../styles/floor-mats.css'

import Step from '../components/step';
import FloorMatColorSelector from '../components/floor-mat-color-selector';
import ProductInfo from '../components/product-info';
import FloorMatImages from '../components/floor-mat-images';
import InfoTabs from '../components/info-tabs';
import FloorMatCarSelector from '../components/floor-mat-car-selector';
import FloorMatProductSelector from '../components/floor-mat-product-selector';
import FloorMatCartButton from '../components/floor-mat-cart-button';
import { useFloorMatStore } from '../stores/floor-mat-store';

function FloorMats() {
  const tabs = useFloorMatStore(state => state.tabs);
  const selectedCar = useFloorMatStore(state => state.selectedCar);
  const setSelectedCar = useFloorMatStore(state => state.setSelectedCar);

  return (
    <Grid container>
      <Grid item xs={12} md={6}>
        <ProductInfo />
        <FloorMatImages />
      </Grid>
      <Grid item xs={12} md={6}>
        <Step title="Step 1 - Select your color" />
        <FloorMatColorSelector />
        <Step title="Step 2 - Select your vehicle" />
        <FloorMatCarSelector selectedCar={selectedCar} setSelectedCar={setSelectedCar} />
        <Step title="Step 3 - Select your set" />
        <FloorMatProductSelector />
        <FloorMatCartButton />
        <InfoTabs tabs={tabs} className='floor-mats-info-tabs' />
      </Grid>
    </Grid>
  )
}

export default FloorMats;
